// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BeforeApproving_suT6a {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 90%;
  margin: 20px auto;
  background: var(--f9-background);
  border-radius: 10px;
  max-height: 50vh;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/modalStatesDoc/ModalStatesDoc.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".BeforeApproving {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 90%;\n  margin: 20px auto;\n  background: var(--f9-background);\n  border-radius: 10px;\n  max-height: 50vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BeforeApproving": `BeforeApproving_suT6a`
};
export default ___CSS_LOADER_EXPORT___;
